import React from 'react'
import Icon from '../components/Icon'
import MarketingImage from './MarketingImage'

const MarketingTwo = () => {
  return (
    <>
      <div className="relative flex flex-col flex-1 overflow-hidden md:flex-row lg:flex-col">
        <a
          href="https://www.morrisons.com/help/morewaystoshop/"
          rel="noreferrer"
          target="_blank"
          className="relative flex justify-start flex-1 aspect-ratio-4/3 sm:aspect-ratio-21/9 lg:aspect-ratio-4/3"
        >
          <MarketingImage
            name="doorstep"
            alt="Morrisons Doorstep"
            className="z-0 block object-cover w-full h-full sm:w-1/2 lg:w-full"
            style={{ position: 'absolute' }}
          />
          <div className="absolute bottom-0 right-0 z-10 flex flex-col w-full p-4 lg:pt-3 xl:pt-4 sm:h-full sm:w-1/2 lg:w-full bg-secondary lg:h-auto">
            <div className="mb-2">
              <h4 className="text-xl font-semibold leading-none text-white">
                More Ways to shop
              </h4>
            </div>
            <div className="flex-1 mb-3">
              <p className="text-base font-semibold leading-tight text-white md:text-sm xl:text-base">
                From Amazon to Deliveroo, check all our ways to get food, drink
                and more to your door.
              </p>
            </div>
            <span className="flex items-center justify-end text-white">
              <span className="pr-2 font-semibold leading-tight whitespace-nowrap">
                Find Out More
              </span>
              <Icon icon="forwardArrow" className="fill-current" />
            </span>
          </div>
        </a>
      </div>
    </>
  )
}

export default MarketingTwo
